import _extends from "@babel/runtime/helpers/esm/extends";
import { createTheme } from '@mui/material/styles/index.js';
import getComponentOverrides from "./Overrides.js";
import typography from "./Typography.js";
import { DARK as DARK_PALETTE, LIGHT as LIGHT_PALETTE } from "./Palettes.js";
import { DEFAULT_THEME_VARIANT, THEME_VARIANTS } from "./Constants.js";

/**
 * Theme creator
 * @param {string} [variant="dark"] - theme variant, either dark or light
 * @returns {object}
 */
var createPlanetTheme = function createPlanetTheme() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_THEME_VARIANT;
  return createTheme({
    components: _extends({}, getComponentOverrides(variant)),
    palette: variant === THEME_VARIANTS.DARK ? DARK_PALETTE : LIGHT_PALETTE,
    typography: typography
  });
};

// Dark & Light Theme variants
export var DARK_THEME = createPlanetTheme(THEME_VARIANTS.DARK);
export var LIGHT_THEME = createPlanetTheme(THEME_VARIANTS.LIGHT);

// Default theme
export var DEFAULT_THEME = DEFAULT_THEME_VARIANT === THEME_VARIANTS.DARK ? DARK_THEME : LIGHT_THEME;
export default {
  DEFAULT_THEME: DEFAULT_THEME,
  DARK_THEME: DARK_THEME,
  LIGHT_THEME: LIGHT_THEME
};